import React, { useContext } from "react";
import ReactBreadcrumb from "@micado-digital/react-breadcrumb/ReactBreadcrumb";
import ReactSVGIcon from "@micado-digital/react-svg-icon/ReactSVGIcon";
import PageContext from "@PageContext";

import styles from "./Breadcrumbs.styles";

const Breadcrumbs = () => {
	const [pageData] = useContext(PageContext);
	const { breadcrumbs = [], lang } = pageData;
	const css = styles();

	return (
		<div className={css.root}>
			<ReactBreadcrumb
				data={breadcrumbs}
				homeLabel="Rupertus"
				homeLink="/"
				lang={lang}
				separator={<ReactSVGIcon size={24} src="/img/icons/bookmark-separator.svg" />}
				showCurrentPage={false}
			/>
		</div>
	);
};

export default Breadcrumbs;
